const GetFormattedData = (inputData, dataFeilds, field1) => {
  const { valueOne, valueTwo } = dataFeilds

  const inputData1 = { ...inputData }
  inputData1[field1[0]] = valueOne
  inputData1[field1[1]] = valueTwo.flat(1)

  return inputData1
}

export default GetFormattedData
